module.exports = __webpack_public_path__ + "img/Insulation services on the FPSO.c399344f.png";